import { Dogs } from '../components/Dogs';
import { Closing } from '../sections/Closing';
import { Gateway } from '../sections/Gateway';
import { Hero } from '../sections/Hero';
import { Invitation } from '../sections/Invitation';

/**
 * The front door: the names, the invitation itself, the dogs, three ways in,
 * and the reply.
 *
 * The invitation and the countdown are the one piece of the old single page
 * that belongs to no section and to all of them — it is the thing a guest
 * came for, and it should not take a click. Everything that is reference
 * rather than invitation moved to a page of its own; see `gateway` in the
 * content file for the three and where each one goes.
 */
export function Home() {
  return (
    <main class="motion-quiet" id="top">
      <Hero />
      <Invitation />
      <Dogs />
      <Gateway />
      <Closing />
    </main>
  );
}
